import { Flex, Switch } from 'antd';
import React from 'react';

const BendItemsContent = (props) => {
  return (
    <Flex vertical>
      <p style={{ fontSize: '9pt' }}>Ein/Aus</p>
      <Switch
        style={{
          maxWidth: 20,
          marginBottom: 10
        }}
        defaultValue={false}
        onChange={props.setBendMode}
      />


    </Flex>
  );
}

export default BendItemsContent;
